import { Post } from "./blog.state";
export namespace BlogActions {
  export class GetPostList {
    static readonly type = '[Blog] Get Post List';
    constructor(public categoriaSlug?: string) { }
  }
  export class GetPostCategories {
    static readonly type = '[Blog] Get Post Categories';
    constructor() { }
  }
  export class GetPost {
    static readonly type = '[Blog] Get Post';
    constructor(public postSlug: string) { }
  }
  export class GetPostPrincipal {
    static readonly type = '[Blog] Get Post Principal';
    constructor(public postSlug: string) { }
  }
  export class ClearBlogState {
    static readonly type = '[Blog] Clear Blog State';
    constructor() { }
  }
}

